import { createUrlResolver, siteNames } from '@seek/melways-sites';

import {
  LANGUAGE,
  SITE,
} from 'src/app/shared/constants/configObjectProperties';
import { getConfig } from 'src/app/utils/config';
import { isStaging } from 'src/app/utils/environment';

export const urlResolver = createUrlResolver({
  site: getConfig(SITE, siteNames.employer.seek.au),
  language: getConfig(LANGUAGE),
  staging: isStaging(),
});
